import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PMCActions, BeneficiariesActions } from 'src/Redux';
import { i18, throwError, SIGN_CANCEL_TYPES, checkJsonProp } from 'src/Utilities';
import { Notification, OperationApproval } from 'src/Components';
import { BeneficiariesNewCheckStatus } from './BeneficiariesNewCheckStatus';

interface IProps {
  authType: string;
  onCancel: () => void;
}

export const BeneficiariesNewSign = ({ authType, onCancel }: IProps) => {
  const dispatch = useDispatch();
  const { signMandateInfo } = useSelector((state: any) => state.BeneficiariesReducers);
  const [productId, setProductId] = useState('');

  const resetSignMandateInfo = () => {
    dispatch(BeneficiariesActions.setSignMandateInfo(null) as any);
  };

  useEffect(() => {
    return () => {
      resetSignMandateInfo();
    };
  }, []);

  const cancelApprove = (type: any, errorCode: string, notificationType = 'warning') => {
    let message;

    switch (type) {
      case SIGN_CANCEL_TYPES.TIMEOUT:
        message = 'PaymentCanceledTimeout';
        break;
      case SIGN_CANCEL_TYPES.MANUAL:
        message = 'PaymentCanceledManual';
        break;
      case SIGN_CANCEL_TYPES.REJECTED:
        message = 'PaymentCanceledRejected';
        break;
      default:
        message = errorCode?.replace('.', '');
        break;
    }

    Notification({
      type: notificationType,
      // @ts-ignore
      message: message ? i18.NotificationTitles[message] : i18.NotificationTitles.Canceled,
      // @ts-ignore
      description: message ? i18.NotificationMessages[message] : i18.NotificationMessages.Canceled,
    });

    resetSignMandateInfo();
    onCancel();
  };

  const successApprove = () => {
    setProductId(signMandateInfo.ProductId);
  };

  const submitMobileApprove = async () => {
    try {
      const response = await dispatch(PMCActions.postAPESCR({ RQ_ID: signMandateInfo.Token }) as any);
      if (response?.payload) {
        if (response.payload.AuthCheckResult === null) {
          return true;
        }

        if (response.payload.AuthCheckResult === false) {
          if (response.payload.ErrorCode) {
            cancelApprove(null, response?.payload?.ErrorCode);
          } else {
            cancelApprove(null, 'BadApproveCode');
          }
        } else if (response.payload.AuthCheckResult === true && response.payload.IsSuccessfull) {
          successApprove();
        }
      } else {
        throwError(response, 'submitMobileApprove');
      }
      return false;
    } catch (error) {
      //  logError(error);
      return false;
    }
  };

  const submitSmsApprove = (values: any) => {
    dispatch(PMCActions.postAPESCR(values) as any).then((response: any) => {
      const IsSuccessfull = checkJsonProp(response, 'payload.IsSuccessfull');
      const ErrorCode = checkJsonProp(response, 'payload.ErrorCode');

      if (IsSuccessfull) {
        successApprove();
      } else {
        cancelApprove(null, ErrorCode, 'error');
      }
    });
  };

  if (productId) {
    return <BeneficiariesNewCheckStatus productId={productId} />;
  }

  return (
    <>
      {signMandateInfo?.IsSuccess && (
        <OperationApproval
          RQ_ID={signMandateInfo.Token}
          AuthType={authType}
          code={signMandateInfo.ChallengeCode}
          cancelApprove={cancelApprove}
          successApprove={successApprove}
          submitSmsApprove={submitSmsApprove}
          submitMobileApprove={submitMobileApprove}
        />
      )}
    </>
  );
};
